//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import GlobalArticleCard from '~/components/molecules/Editorial/Global/GlobalArticleCard.vue';
export default {
  name: 'GlobalListArticleCard',
  components: {
    GlobalArticleCard
  },
  props: {
    articles: {
      type: Array,
      required: true
    },
    filters: {
      type: Array,
      required: true
    }
  },
  methods: {
    articleColor(arg) {
      const filter = this.filters.find(e => e.label === arg);
      return filter ? filter.color : '#000';
    }

  }
};